module.exports = __webpack_public_path__ + "img/letrero-movil.461805d9.png";